import Button from '@components/Forms/Button';
import FormGroup from '@components/Forms/FormGroup';
import {LIUNE_ARTDOOR_MODEL_DROPDOWN} from '@constants/liune-arts';
import {useProductDisplay} from '@contexts/index';
import {ProductDisplaysEnum} from '@enums/product-display';
import {useTranslation} from 'next-i18next';
import Image from 'next/image';
import {useRouter} from 'next/router';
import {useCallback, useEffect, useState} from 'react';
import {Input, Modal, ModalBody, ModalHeader} from 'reactstrap';
import styles from './style.module.css';
export const ProductFamilyDimensions = ({
  productGroupId,
  type = ProductDisplaysEnum.PRODUCT_GROUP_DISPLAY_LIUNE_FAMILY,
  productGroupUID,
  heightLabel,
  widthLabel,
  lengthLabel,
}: {
  productGroupId: number;
  type: ProductDisplaysEnum;
  productGroupUID: string;
  heightLabel: string;
  widthLabel: string;
  lengthLabel: string;
}) => {
  const [showDimension, setShowDimension] = useState(false);
  const {locale, query, push} = useRouter();
  const {
    PRODUCT_GROUP_DISPLAY_LIUNE_DOOR_FRAME,
    PRODUCT_GROUP_DISPLAY_LIUNE_SURFACE_DOOR,
    PRODUCT_GROUP_DISPLAY_LIUNE_ART_DOOR,
    PRODUCT_GROUP_DISPLAY_LIUNE_SPECIAL_DOOR_FRAME,
    PRODUCT_GROUP_DISPLAY_LIUNE_ELEMENT,
  } = ProductDisplaysEnum;
  const {t} = useTranslation('product-display');

  const {
    state,
    getSalesUnitLength,
    getSalesUnitHeight,
    getSalesUnitWidth,
    getProductByDimension,
    getProductPrices,
    setKeyValuePairs,
    getProductDimensions,
  } = useProductDisplay();

  const {
    product,
    load_product_prices,
    quantity,
    dimensions: {
      width,
      height,
      length,
      productDimensionsLoaded,
      productLengths,
      productHeights,
      productWidths,
    },
  } = state;

  const handleOptionSelect = (data: object) => {
    delete query.slug;
    const updatedQeury = {...query, ...data};
    const queryArr = Object.keys(updatedQeury).map(
      key => `${key}=${updatedQeury[key]}`
    );
    push(`${location.pathname}?${queryArr.join('&')}`, undefined, {
      shallow: true,
    });
  };

  const getSelectedModel = useCallback(() => {
    let selectedModel = '';
    if (query.model) {
      selectedModel =
        typeof query.model === 'string' ? query.model : query?.model[0];
    }
    let modelName = LIUNE_ARTDOOR_MODEL_DROPDOWN[productGroupId].find(
      x => x === selectedModel
    );
    if (!modelName) {
      modelName = LIUNE_ARTDOOR_MODEL_DROPDOWN[productGroupId][0];
    }
    return modelName || '';
  }, [query.model]);

  useEffect(() => {
    if (productDimensionsLoaded) {
      let queryLength: number | undefined = undefined;
      if (!isNaN(Number(query.length))) queryLength = Number(query.length);
      getSalesUnitLength(queryLength);
      if (type === PRODUCT_GROUP_DISPLAY_LIUNE_ART_DOOR) {
        setKeyValuePairs({
          model: getSelectedModel(),
        });
      }
    } else {
      getProductDimensions(productGroupId);
    }
  }, [query.length, productDimensionsLoaded]);

  useEffect(() => {
    if (length) {
      let queryHeight: number | undefined = undefined;
      if (!isNaN(Number(query.height))) queryHeight = Number(query.height);
      getSalesUnitHeight(queryHeight);
    }
  }, [length, query.height]);

  useEffect(() => {
    if (height) {
      let queryWidth: number | undefined = undefined;
      if (!isNaN(Number(query.width))) queryWidth = Number(query.width);
      getSalesUnitWidth(queryWidth);
    }
  }, [height, query.width]);

  useEffect(() => {
    if (height && width && length) {
      getProductByDimension(productGroupId);
    }
  }, [width]);

  useEffect(() => {
    if (type === PRODUCT_GROUP_DISPLAY_LIUNE_ART_DOOR) {
      const selectedModel = getSelectedModel();
      setKeyValuePairs({
        model: selectedModel,
      });
    }
  }, [query.model]);

  useEffect(() => {
    if (load_product_prices && quantity && product?.id) {
      getProductPrices();
    }
  }, [load_product_prices, quantity]);
  return (
    <>
      {!!productGroupUID && (
        <Modal isOpen={showDimension} size={'lg'}>
          <ModalHeader toggle={() => setShowDimension(!showDimension)}>
            <h4 className={'mb-0'}>{t<string>('product_dimensions')}</h4>
          </ModalHeader>
          <ModalBody>
            <div
              style={{
                minHeight: '500px',
                width: 'auto',
                padding: '20px',
                position: 'relative',
              }}
            >
              <Image
                alt={`${productGroupUID}_${locale?.split('-')?.[0]}.jpg`}
                src={`https://assets.liunedoor.com/upload/mittakuvat/mittakuva_${productGroupUID}_${
                  locale?.split('-')?.[0]
                }.jpg`}
                fill
              />
            </div>
          </ModalBody>
        </Modal>
      )}

      <div className={`${styles.productDimensionsInputs}`}>
        {type === PRODUCT_GROUP_DISPLAY_LIUNE_ART_DOOR && (
          <div className={'mb-1'} style={{width: '100%'}}>
            <FormGroup>
              <label htmlFor="">{t<string>('select_door_model')}</label>
              <Input
                type={'select'}
                defaultValue={query.model}
                // onChange={e => setKeyValuePairs({model: e.target.value})}
                onChange={e => handleOptionSelect({model: e.target.value})}
                className={'form-control'}
              >
                {LIUNE_ARTDOOR_MODEL_DROPDOWN[productGroupId]?.map(
                  (model, key) => {
                    return (
                      <option key={key} value={model}>
                        {model}
                      </option>
                    );
                  }
                )}
              </Input>
            </FormGroup>
          </div>
        )}
        <div className={`${styles.dimensionInput}`}>
          <FormGroup>
            <label htmlFor="">{lengthLabel} (mm)</label>
            <Input
              value={length || undefined}
              type={'select'}
              // onChange={e => setLength(e.target.value)}
              onChange={e => handleOptionSelect({length: e.target.value})}
              className={'form-control'}
            >
              {productLengths.map((value, key) => {
                return (
                  <option key={key} value={value}>
                    {value}
                  </option>
                );
              })}
            </Input>
          </FormGroup>
        </div>
        <div
          className={`${styles.dimensionInput} ${
            [
              PRODUCT_GROUP_DISPLAY_LIUNE_DOOR_FRAME,
              PRODUCT_GROUP_DISPLAY_LIUNE_SURFACE_DOOR,
              PRODUCT_GROUP_DISPLAY_LIUNE_SPECIAL_DOOR_FRAME,
              PRODUCT_GROUP_DISPLAY_LIUNE_ELEMENT,
            ].includes(type!) && 'order-1'
          }`}
        >
          <FormGroup>
            <label htmlFor="">{heightLabel} (mm)</label>
            {/*{type === PRODUCT_GROUP_DISPLAY_LIUNE_DOOR_FRAME*/}
            {/*  ? t('door')*/}
            {/*  : type === PRODUCT_GROUP_DISPLAY_LIUNE_SURFACE_DOOR*/}
            {/*  ? `${t<string('thickness')}`*/}
            {/*  : `${t<string('frame')}`}*/}

            <Input
              value={height || undefined}
              type={'select'}
              // onChange={e => setHeight(e.target.value)}
              onChange={e => handleOptionSelect({height: e.target.value})}
              className={'form-control'}
            >
              {productHeights.map((value, key) => {
                {
                  return (
                    <option key={key} value={value}>
                      {value}
                    </option>
                  );
                }
              })}
            </Input>
          </FormGroup>
        </div>

        <div className={`${styles.dimensionInput} `}>
          <FormGroup>
            <label htmlFor="">
              {widthLabel} (mm)
              {/*{' '}*/}
              {/*{type === PRODUCT_GROUP_DISPLAY_LIUNE_FAMILY*/}
              {/*  ? t('access_opening')*/}
              {/*  : type === PRODUCT_GROUP_DISPLAY_LIUNE_SPECIAL_DOOR_FRAME*/}
              {/*  ? t('mounting_hole_width')*/}
              {/*  : `${t<string('width')}  (mm)`}*/}
            </label>
            <Input
              type={'select'}
              // onChange={e => setWidth(e.target.value)}
              onChange={e => handleOptionSelect({width: e.target.value})}
              value={width || undefined}
              className={'form-control'}
            >
              {productWidths.map((value, key) => {
                {
                  return (
                    <option key={key} value={value}>
                      {value}
                    </option>
                  );
                }
              })}
            </Input>
          </FormGroup>
        </div>
        {!!productGroupUID && (
          <div className={'mb-1 order-3'} style={{width: '100%'}}>
            <Button onClick={() => setShowDimension(true)} block={true}>
              {t<string>('product_dimensions')}
            </Button>
          </div>
        )}
      </div>
    </>
  );
};
